<script setup lang="ts">
// #737: お客様の声の共通マーキー（白カードが横に流れる）。
// 子供の声（ForEducationSection）のマーキーで使用。大人の声は各セクションに静置する VoiceCard に移行した。
// 背景色には依存しない（白カードなので、パーチメント上でも黒背景上でも成立する）。
import type { Testimonial } from '@/data/testimonials'

interface Props {
  voices: Testimonial[]
}
defineProps<Props>()
</script>

<template>
  <div class="tm-marquee">
    <div class="tm-track">
      <figure
        v-for="item in voices"
        :key="`tm-a-${item.id}`"
        class="tm-card"
      >
        <blockquote class="tm-quote">
          {{ item.quote }}
        </blockquote>
        <figcaption class="tm-author">
          — {{ item.author }}
        </figcaption>
      </figure>
      <!-- 途切れなく回すための複製（読み上げ対象からは除外） -->
      <figure
        v-for="item in voices"
        :key="`tm-b-${item.id}`"
        class="tm-card"
        aria-hidden="true"
      >
        <blockquote class="tm-quote">
          {{ item.quote }}
        </blockquote>
        <figcaption class="tm-author">
          — {{ item.author }}
        </figcaption>
      </figure>
    </div>
  </div>
</template>

<style scoped>
.tm-marquee {
  overflow: hidden;
  width: 100%;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
}

.tm-track {
  display: inline-flex;
  animation: tm-scroll 60s linear infinite;
}

.tm-card {
  flex: none;
  width: clamp(240px, 72vw, 340px);
  margin: 0 8px;
  padding: 20px 22px;
  background: #fff;
  border: 1px solid var(--landing-color-border-mint);
  border-radius: var(--landing-radius);
  box-shadow: var(--landing-shadow-light);
  color: var(--landing-color-text-dark);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tm-quote {
  margin: 0;
  font-size: clamp(0.92rem, 1.1vw, 1.02rem);
  line-height: 1.7;
  font-weight: 500;
}

.tm-quote::before { content: "“"; }
.tm-quote::after { content: "”"; }

.tm-author {
  margin: 14px 0 0;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--landing-color-teal-darker);
  text-align: right;
}

@keyframes tm-scroll {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .tm-track {
    animation: none;
    flex-wrap: wrap;
    justify-content: center;
  }

  .tm-card {
    margin: 8px;
  }

  .tm-card[aria-hidden="true"] {
    display: none;
  }
}
</style>
